import { HttpClient } from '@adapters/HttpClient';
import { ReturnedModel, ReturnedPageResponse } from '../models/Returned';

export interface ReturnedFilters {
  searchTerm?: string;
  type_ids?: number[];
  product_ids?: number[];
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  page?: number;
  limit?: number;
  event_ids?: number[];
}

export interface ReturnedPage {
  returned: ReturnedModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class ReturnedApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getReturnedPaginated(
    filters: ReturnedFilters = {}
  ): Promise<ReturnedPage> {
    const {
      searchTerm = '',
      sortBy = 'id',
      sortDirection = 'desc',
      page = 1,
      limit = 15,
    } = filters;

    const params: any = {
      ...(searchTerm && { search: searchTerm }),
      ...(sortBy && { order_by: sortBy }),
      ...(sortDirection && { order_direction: sortDirection }),
      page,
      per_page: limit,
    };

    const response = await this.httpClient.get<ReturnedPageResponse>(
      '/returned-receptions',
      params
    );

    return {
      returned: response.data,
      nextPage:
        response.meta.currentPage < response.meta.lastPage
          ? response.meta.currentPage + 1
          : undefined,
      hasMore: response.meta.currentPage < response.meta.lastPage,
      total: response.meta.total,
    };
  }

  async getAll(): Promise<ReturnedModel[]> {
    const response = await this.getReturnedPaginated();
    return response.returned;
  }

  /**
   * Crear una nueva recepción de devoluciones
   * @returns Respuesta de la API
   */
  async createReturnedReception(): Promise<{
    success: boolean;
    message: string;
  }> {
    try {
      const response = await this.httpClient.post<any>(
        '/returned-receptions',
        {}
      );

      return {
        success: true,
        message: response.message || 'Recepción creada exitosamente',
      };
    } catch (error: any) {
      console.log('🔍 ReturnedApiAdapter - Error creating reception:', error);

      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear la recepción',
      };
    }
  }
}
